export const HEREWEARE_INSTALL_URL = "https://link.hereweare.io/install";
export const HEREWEARE_APP_STORE_URL = "https://apps.apple.com/app/id1491869024";
export const HEREWEARE_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.hsoft.hwa";
export const HEREWEARE_QR_PATH = "/install";

type MobileInstallPlatform = "ios" | "android" | "other";

export function getMobileInstallPlatform(): MobileInstallPlatform | null {
  if (typeof navigator === "undefined") return null;

  const userAgent = navigator.userAgent || "";
  const navigatorWithData = navigator as Navigator & {
    userAgentData?: { mobile?: boolean };
  };

  if (/Android/i.test(userAgent)) return "android";

  const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

  if (/iPhone|iPad|iPod/i.test(userAgent) || isIPadOS) return "ios";

  const hasMobileUserAgent = /webOS|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  if (hasMobileUserAgent || navigatorWithData.userAgentData?.mobile) return "other";

  return null;
}

export function isMobileInstallDevice() {
  return getMobileInstallPlatform() !== null;
}

export function getMobileInstallUrl() {
  const platform = getMobileInstallPlatform();

  if (platform === "android") return HEREWEARE_PLAY_STORE_URL;
  if (platform === "ios") return HEREWEARE_APP_STORE_URL;

  return HEREWEARE_INSTALL_URL;
}
